// NPM Imports
import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { withRouter } from "react-router-dom";
import { Tooltip, Toastr, Button, Input } from "@revvsales/components";

// Components Imports
import { ReactSelect } from "../../../commonComponents";

// Actions Imports
import { WorkFlowActions } from "../../../actions";

// Destructuring
const { createWorkFlow } = WorkFlowActions;

// Declarations
const WORKFLOW_TRIGGER_TYPES = ["Automatic", "Manual"];

class AddWorkFlow extends Component {
  // AV_TO_DO :: The "scope" field has to be dynamic
  state = {
    name: "",
    description: "",
    scope: WORKFLOW_TRIGGER_TYPES[0],
    selectedFlow: "DEAL",
    options: [
      {
        name: "DEAL",
        label: "Deal approval flow",
      },
    ],
    showButtonLoader: false,
    disableAdd: true,
  };

  _validateFields = () => {
    const { name, description } = this.state;
    let disableAdd = false;
    if (name.trim() === "" || description.trim() === "") {
      disableAdd = true;
    }
    this.setState({ disableAdd });
  };

  _initiateValidations = field => {
    if (field === "name" || field === "description") {
      this._validateFields();
    }
  };

  _selectFlow = value => {
    this.setState({ selectedFlow: value });
  };

  _onInputChange = (event, field) => {
    const obj = {};
    obj[field] = event.target.value;
    this.setState(obj, () => this._initiateValidations(field));
  };

  _onSelectChange = (field, value) => {
    const obj = {};
    obj[field] = value;
    this.setState(obj);
  };

  _onSubmit = e => {
    e.preventDefault();
    const { description, name, scope, selectedFlow } = this.state;

    if (
      description !== "" &&
      name !== "" &&
      Object.keys(scope).length > 0 &&
      selectedFlow !== null
    ) {
      // AV_TO_DO :: "scope_type" field has to be change
      // ex: scope_type: scope.label toUpperCase()
      const payload = {
        name,
        description,
        scope_type: scope.toUpperCase(),
        entity: selectedFlow,
        active: true,
      };

      this.setState({ showButtonLoader: true });
      this.props
        .createWorkFlow(payload)
        .then(response => {
          this.setState({ showButtonLoader: false });
          this.props.history.push(`workflow/${response.id}`);
        })
        .catch(error => {
          console.error(`AddWorkFlow => _onSubmit => ${error}`);
          this.setState({ showButtonLoader: false });
        });
    } else {
      Toastr.showToastr({
        type: "warning",
        message: "Please fill in the required fields.",
        timeout: 2000,
      });
    }
  };

  render() {
    return (
      <Fragment>
        <div className="addworkflow-container">
          <div className="addworkflow-title">Create workflow</div>
          <div className="addworkflow-form">
            <span className="addworkflow-subtitle addworkflow-hide">
              You can create your approval workflows here.
            </span>
            <div className="addworkflow-options addworkflow-hide">
              {this.state.options.map(option => (
                <div
                  className={`addworkflow-item ${
                    this.state.selectedFlow === option.name ? "is-active" : ""
                  }`}
                  key={option.name}
                  onClick={() => this._selectFlow(option.name)}
                  onKeyPress={() => this._selectFlow(option.name)}
                  role="button"
                  tabIndex="0">
                  {option.label}
                </div>
              ))}
              <div className="addworkflow-item is-disabled">
                More workflows coming soon!
              </div>
            </div>
            <div className="addworkflow-details">
              <div className="addworkflow-div-wrapper">
                <span className="addworkflow-label">
                  Workflow Name
                  <span className="required-input">*</span>
                </span>
                <Input
                  autoFocus
                  className="addworkflow-input"
                  placeholder="Enter a name for your workflow."
                  value={this.state.name}
                  onChange={e => this._onInputChange(e, "name")}
                  data-test="addworkflow-name-input"
                />
              </div>
              <div className="addworkflow-div-wrapper">
                <span className="addworkflow-label">
                  Description<span className="required-input">*</span>
                </span>
                <Input
                  className="addworkflow-input"
                  placeholder="Enter a description for your workflow."
                  value={this.state.description}
                  onChange={e => this._onInputChange(e, "description")}
                  data-test="addworkflow-desc-input"
                />
              </div>
              <div className="addworkflow-div-wrapper addworkflow-hide">
                <span className="addworkflow-label">
                  Trigger Type<span className="required-input">*</span>
                  <Tooltip
                    placement="top"
                    align={{
                      offset: [0, 4],
                    }}
                    overlay="Trigger Type">
                    <i className="whats-this">
                      <FontAwesomeIcon icon={["far", "question-circle"]} />
                    </i>
                  </Tooltip>
                </span>
                <ReactSelect
                  isSearchable
                  valueKey="name"
                  onChange={value => this._onSelectChange("scope", value)}
                  options={WORKFLOW_TRIGGER_TYPES}
                  value={this.state.scope}
                  isDisabled
                  data-test="addworkflow-type-select"
                />
              </div>
            </div>
            <div className="addworkflow-actions">
              <Button
                className="addworkflow-action-btn is-cancel"
                onClick={this.props.onCancel}
                data-test="addworkflow-cancel-btn">
                Cancel
              </Button>
              <Button
                className="addworkflow-action-btn"
                type="submit"
                isLoading={this.state.showButtonLoader}
                onClick={this._onSubmit}
                disabled={this.state.disableAdd}
                data-test="addworkflow-create-btn">
                Create
              </Button>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

const mapDispatchToProps = {
  createWorkFlow,
};

export default connect(
  null,
  mapDispatchToProps,
)(withRouter(AddWorkFlow));



// WEBPACK FOOTER //
// ./src/components/WorkFlow/AddWorkFlow/AddWorkFlow.js